import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import mealPlanConfig, { TMealPlan } from '@mindfulchefuk/config/mealPlanConfig'
import { setExcludedFoodGroups } from '@mindfulchefuk/actions/recipesActions'
import { setBasketMealPlan } from '@mindfulchefuk/actions/basketActions'
import { logMealPlanChange } from '@mindfulchefuk/features/Onboarding/utils/onboardingAnalytics'
import { TOnboardingRecipeFilterHandlers } from '@mindfulchefuk/onboarding/components/OnboardingChooseRecipes/OnboardingChooseRecipesFilters/OnboardingRecipeFilterHandlers.types'

export const useOnMealPlanChange =
  (): TOnboardingRecipeFilterHandlers['mealPlan'] => {
    const dispatch = useDispatch()

    const onMealPlanChange = useCallback<
      TOnboardingRecipeFilterHandlers['mealPlan']
    >(
      (newMealPlan: string) => {
        const { excludedFoodGroups } = mealPlanConfig.find(
          (mealPlan) => mealPlan.value === newMealPlan
        )
        logMealPlanChange(newMealPlan)

        dispatch(setBasketMealPlan(newMealPlan as TMealPlan))
        dispatch(setExcludedFoodGroups(excludedFoodGroups))
      },
      [dispatch]
    )

    return onMealPlanChange
  }
